import { playAudio } from "../../utils/btnAudio";
import { CButton } from "../CommonComponents";
import { useNavigate } from "react-router-dom";

function RecipeItem({ article }) {
  const navigate = useNavigate();
  let myRegex = /<img[^>]+src="([^">]+)"/g;

  let match = myRegex.exec(article.content);

  let thumbnail =
    match && match[1].includes("cdn")
      ? match[1]
      : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVXk7-kB2fclCNbOr_bYVEnwFHBnYVCPV1L_8QghQ6XQ&s";
  function removeImageTags(htmlContent) {
    // This regular expression matches all <img> tags
    const imgTagRegex = /<img[^>]*>/g;
    return htmlContent.replace(imgTagRegex, "");
  }

  return (
    <div className="w-full flex flex-col h-[450px] gap-5 rounded-3xl overflow-hidden  items-center p-8 shadow-md hover:shadow-lg transition-shadow dark:bg-orange-300 bg-white">
      <div className="h-[250px] w-[250px] overflow-hidden rounded-lg">
        <img
          src={thumbnail}
          alt={article.title}
          className="w-[250px] h-[250px] object-cover transition duration-400 rounded-lg transform hover:scale-110"
        />
      </div>
      <div className="flex flex-col justify-between h-full">
        <div>
          {" "}
          <p className="text-teal-900 font-bold text-lg text-center">
            {article.title}
          </p>
          <div
            className={`text-teal-900 text-sm text-center`}
            dangerouslySetInnerHTML={{
              __html: `${removeImageTags(article.description).slice(
                0,
                150
              )}....`,
            }}
          ></div>
        </div>
        <CButton
          variant="orange"
          type="button"
          className="w-full"
          onClick={() => {
            playAudio();
            localStorage.setItem("article", JSON.stringify(article));
            navigate("/blog/" + article.title.split(" ").join("-"));
          }}
        >
          View More
        </CButton>
      </div>
    </div>
  );
}

export default RecipeItem;
